import _ from 'lodash';
import events from './events';
import errors from './errors.json';

const registerEvents = _.noop;

export { events, errors, registerEvents };
